import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { ApiUserService } from '../../../core/service/api-user.service';
import { ChangeImageComponent } from '../change-image/change-image.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-Change_Mail',
  templateUrl: './Change_Mail.component.html',
  styles: []
})
export class Change_MailComponent implements OnInit {
  @HostListener('window:resize', ['$event'])

  Step: 1 | 2 = 1
  loading: boolean = false
  firstFormGroup = this._formBuilder.group({
    email: ['', [Validators.required, Validators.maxLength(50), Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-z]{2,4}$")]],
  });
  secondFormGroup = this._formBuilder.group({
    otp: ['', Validators.required],
  });
  getScreenWidth: number = window.innerWidth;

  constructor(private _config: ConfigService,
    private _formBuilder: FormBuilder,
    private apiUserService: ApiUserService,
    public dialogRef: MatDialogRef<ChangeImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string) { }

  ngOnInit() {

  }

  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  goForward(stepper: MatStepper) {
    stepper.next();
  }

  SubmitMail(stepper: MatStepper) {
    if (this.firstFormGroup.valid) {
      this.loading = true;
      let modal = { ... this.firstFormGroup.value }
      this.apiUserService.SendOtpToUpdateMail(modal, this.data).subscribe(
        (res: any) => {
          this.loading = false;
          this._config.toastrService.clear();

          this._config.toastrService.success(this._config.translate.instant("users.Check your email please!"))
          stepper.next();
          this.Step = 2
        },
        (error: any) => {
          this.loading = false;
          this._config.showErrors(error)
        }
      )
    }
  }

  SubmitOTP(stepper: MatStepper) {

    if (this.firstFormGroup.valid) {
      this.loading = true;
      let modal = { ... this.firstFormGroup.value, ... this.secondFormGroup.value }

      this.apiUserService.UpdateEmail(modal, this.data).subscribe(
        (res: any) => {

          this.loading = false;
          this._config.toastrService.clear();
          this._config.toastrService.success(this._config.translate.instant("users.E-mail updated successfully"))
          stepper.next();
          this.dialogRef.close("success")
        },
        (error: any) => {

          this.loading = false;
          this._config.showErrors(error)
        }
      )
    }

  }


  hasError(GroupName: FormGroup, controlName: string, errorName: string) {
    return GroupName.controls[controlName].hasError(errorName);
  }

  onWindowResize(event: any) {
    this.getScreenWidth = event.target.innerWidth;
  }

}
